import { ConfigModel } from '../core/interfaces/config';

export class PagesConfig implements ConfigModel {
	public config: any = {};

	constructor() {
		this.config = {
			'/': {
				page: {
					title: 'Anasayfa',
					desc: 'Latest updates and statistic charts'
				}
			},
			builder: {
				page: { title: 'Layout Builder', desc: 'Layout builder' }
			},
			header: {
				actions: {
					page: { title: 'Actions', desc: 'actions example page' }
				}
			},
			profile: {
				page: { title: 'Kullanıcı Profili', desc: '' }
			},
			404: {
				page: { title: '404 Sayfa Bulunamadı', desc: '', subheader: false }
			}
		};
	}
}